function createSVGElement(name: string, attributes?) {
  const element = document.createElementNS('http://www.w3.org/2000/svg', name);

  // eslint-disable-next-line no-restricted-syntax, guard-for-in
  for (const attributeName in attributes) {
    element.setAttributeNS(null, attributeName, attributes[attributeName]);
  }

  return element;
}

function addPathToSvg(svg, outline, attrs) {
  if (outline) {
    const path = createSVGElement('path', attrs);

    svg.appendChild(path);

    return path;
  }
}

function createOutlines(elementId, outlines = {}, { width = 0, height = 0, clickable = true }) {
  const node = document.getElementById(elementId);
  const svg = createSVGElement('svg', { viewBox: `0 0 ${width} ${height}`, width, height });

  const categoriesPaths = {};
  const sectorsPaths = {};

  Object.keys(outlines).forEach((sectorId) => {
    if (outlines[sectorId].paths) {
      const categoryId = sectorId;
      const paths = outlines[categoryId].paths;
      const pathsArray = Array.isArray(paths) ? paths : JSON.parse(paths);

      pathsArray.forEach((path) => {
        const { isCategory } = outlines[categoryId];
        const pathEl = addPathToSvg(svg, path, {
          'data-id': sectorId,
          d: path,
          fill: 'rgba(0, 0, 0, 0)',
          category: isCategory && clickable,
        });
        (categoriesPaths[categoryId] = categoriesPaths[categoryId] || []).push(pathEl);
      });
    } else {
      const outline = outlines[sectorId].path;
      const isStand = outlines[sectorId].stand;

      const pathEl = addPathToSvg(svg, outline, {
        'data-id': sectorId,
        d: outline,
        stand: isStand && clickable,
        fill: 'rgba(0, 0, 0, 0)',
      });
      sectorsPaths[sectorId] = pathEl;
    }
  });
  node.appendChild(svg);

  return { svg, categoriesPaths, sectorsPaths };
}

function isSvgPath(str) {
  if (typeof str !== 'string') return false;

  str = str.trim();
  return (
    /^[mzlhvcsqta]\s*[-+.0-9][^mlhvzcsqta]+/i.test(str) && /[\dz]$/i.test(str) && str.length > 4
  );
}

export const generateUniqueIdForSvg = () => Math.random().toString(36).slice(2, 9);

export { createSVGElement, createOutlines, isSvgPath };
